import React from 'react'
import './style.module.scss'

const RadioSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    width="24px"
    viewBox="0 -960 960 960"
  >
    <defs>
      <mask id="hole">
        <circle r="100%" cx="480" cy="-480" fill="white" />
        <circle cx="480" cy="-480" r="288" fill="black" />
      </mask>
    </defs>
    <circle cx="480" cy="-480" r="360" fill="rgb(31 34 38)" mask="url(#hole)" />
    <circle
      className="Radio-dot"
      cx="480"
      cy="-480"
      r="165"
      fill="rgb(31 34 38)"
    />
  </svg>
)

export type RadioProps = {
  id: string
  name: string
  value: string
  label: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  large?: boolean
  reference?: React.RefObject<HTMLInputElement>
  testId?: string
}

export const Radio = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  disabled,
  large,
  reference,
  testId
}: RadioProps) => {
  return (
    <div
      className={`Radio${large ? ' Radio--large' : ''}`}
      data-testid={testId ? `${testId}-wrapper` : undefined}
    >
      <input
        className="Radio-button"
        id={id}
        name={name}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        ref={reference}
        data-testid={testId ? `${testId}-input` : undefined}
      />
      <label
        htmlFor={id}
        className="Radio-label"
        data-testid={testId ? `${testId}-label` : undefined}
      >
        <RadioSvg />
        <span>{label}</span>
      </label>
    </div>
  )
}
